import React from 'react';
import LoadFile from './LoadFile.js';
import Viewer from './Viewer.js';
import './App.css';

function App() {
  const [getIndex, setIndex] = React.useState();
  const [getIncludeLunr, setIncludeLunr] = React.useState(false);

  const onUpdateIndex = (e) =>
  {
    setIndex(e);
  }

  var items = [];

  if (getIndex)
  {
    items.push(
      <Viewer key={items.length} Index={getIndex} getIncludeLunr={getIncludeLunr}/>
    );
  }
  else
  {
    items.push(
      <div key={items.length} className="container-fluid vcenter d-flex align-items-center justify-content-center">
        <LoadFile onUpdateIndex={onUpdateIndex} getIncludeLunr={getIncludeLunr} setIncludeLunr={setIncludeLunr}/>
      </div>
    );
  }

  return (
    <div>
      {items}
    </div>
  );
}

export default App;
